import { axiosInstance } from 'boot/axios.js'

export async function measures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'b2b-off/measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('measures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function tyreCategories(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'tyre-categories',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('tyreCategories', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}
